<template>
  <section class="upload-hmi">
    <header>
      <div class="flow-btn">
        <button @click.prevent="$emit('back')">{{ $t('buttons.back') }}</button>
      </div>
      <div class="title">
        <h1>{{ $t('create.titleHMI') }}:</h1>
      </div>
      <div class="flow-btn">
        <button :class="{ 'alt-btn': !isSomeChecked }" @click.prevent="nextStep">{{ $t(nextLabel) }}</button>
      </div>
    </header>
    <div class="toggle-buttons">
      <div class="btn-group">
        <div class="type-title"><h1>{{ $t('create.hmiLocationTitle') }}</h1></div>
        <toggle-button v-for="tag in locationBtns" :key="tag.id" v-model="tag.checked" :label="$t('tags.' + tag.id)" @input="checkType(tag)"></toggle-button>
      </div>
      <div class="btn-group">
        <div class="type-title"><h1>{{ $t('create.hmiPartnerTitle') }}</h1></div>
        <toggle-button v-for="tag in partnerBtns" :key="tag.id" v-model="tag.checked" :label="$t('tags.' + tag.id)" @input="checkType(tag)"></toggle-button>
      </div>
    </div>
  </section>
</template>

<script>
import ToggleButton from '@/components/ToggleButton.vue'
import { SAVE_MEDIA } from '@/store/actions.type'
import { TOGGLE_TAGS_CHECKED } from '@/store/mutations.type'
// import { mapGetters } from 'vuex'

export default {
  name: 'upload-hmi',
  components: {
    ToggleButton
  },
  data() {
    return {
      tags: JSON.parse(JSON.stringify(this.$store.getters.tags))
    }
  },
  computed: {
    isSomeChecked() {
      return this.tags.some(tag => tag.checked)
    },
    nextLabel() {
      return this.isSomeChecked ? 'buttons.continue' : 'buttons.skipForNow'
    },
    locationBtns() {
      const ret = [];
      for (const t in this.tags) if (this.tags[t].type === 'location') ret.push(this.tags[t]);
      return ret;
    },
    partnerBtns() {
      const ret = [];
      for (const t in this.tags) if (this.tags[t].type === 'partner') ret.push(this.tags[t]);
      return ret;
    },
  },
  methods: {
    nextStep() {
      this.$store.commit(TOGGLE_TAGS_CHECKED, this.tags)
      this.$store.dispatch(SAVE_MEDIA, false)
      this.$emit('next')
    },
    checkType(tag) {
      this.dirty = true
      if (tag.type && tag.checked) {
        this.tags.forEach(aTag => {
          if (tag.type === 'location') {
            if (aTag !== tag && aTag.type === tag.type) {
              this.$set(aTag, 'checked', false)
            }
          } else if (tag.type === 'partner') {
            if (aTag !== tag && aTag.type === tag.type) {
              this.$set(aTag, 'checked', false)
            }
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-buttons {
  margin: 30px 0 0 -25px;
}

.btn-group {
  display: inline-block;

  .type-title {
    text-align: left;

    h1 {
      margin-left: 25px;
    }
  }
}
</style>
